export default {
  toggleLoading(state, loading) {
    state.loading = loading;
  },
  setShipperMacroStates(state, macroStates) {
    state.macroStates = macroStates;
  },
  setShipperMicroStates(state, microStates) {
    state.microStates = microStates;
  },
};



// WEBPACK FOOTER //
// ./src/stores/order-status/mutations.js